const config: PageConfigurationType = {
    breadCrumbs: [{ label: 'home', path: 'home' }, 'services.serviceTypes']
}

export default config
